import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

// URL prefix → display info
const URL_LOCALES: Array<{ prefix: string; name: string; flag: string; flarumLocale: string }> = [
    { prefix: 'en', name: 'English', flag: '🇺🇸', flarumLocale: 'en' },
    { prefix: 'ua', name: 'Українська', flag: '🇺🇦', flarumLocale: 'uk' },
    { prefix: 'hi', name: 'हिन्दी', flag: '🇮🇳', flarumLocale: 'hi' },
    { prefix: 'es', name: 'Español', flag: '🇪🇸', flarumLocale: 'es' },
    { prefix: 'pt', name: 'Português', flag: '🇧🇷', flarumLocale: 'pt-BR' },
    { prefix: 'tr', name: 'Türkçe', flag: '🇹🇷', flarumLocale: 'tr' },
    { prefix: 'ko', name: '한국어', flag: '🇰🇷', flarumLocale: 'ko' },
    { prefix: 'vi', name: 'Tiếng Việt', flag: '🇻🇳', flarumLocale: 'vi' },
];

// Flarum locale → URL prefix
const FLARUM_TO_PREFIX: Record<string, string> = {};
URL_LOCALES.forEach((l) => { FLARUM_TO_PREFIX[l.flarumLocale] = l.prefix; });

const PREFIX_REGEX = /^\/(ua|hi|es|pt|tr|ko|vi)(\/.*)?$/;

export default class LanguageSwitcher extends Component {
    view() {
        const flarumLocale = app.data.locale || 'en';
        const currentPrefix = FLARUM_TO_PREFIX[flarumLocale] || 'en';

        return (
            <select
                className="LanguageSwitcher-select"
                value={currentPrefix}
                onchange={(e: Event) => {
                    const prefix = (e.target as HTMLSelectElement).value;
                    this.switchLocale(prefix);
                }}
            >
                {URL_LOCALES.map((l) => (
                    <option value={l.prefix}>
                        {l.flag} {l.name}
                    </option>
                ))}
            </select>
        );
    }

    switchLocale(prefix: string) {
        // Get current path, strip any existing locale prefix
        let path = window.location.pathname;
        const match = path.match(PREFIX_REGEX);
        if (match) {
            path = match[2] || '/';
        }

        // Build full absolute URL to guarantee a real page load
        const newPath = prefix === 'en' ? path : '/' + prefix + path;
        const fullUrl = window.location.origin + newPath + window.location.search;

        // Smooth fade-out before navigation to prevent white flash
        const root = document.documentElement;
        root.style.transition = 'opacity 0.15s ease';
        root.style.opacity = '0';

        setTimeout(() => {
            window.location.replace(fullUrl);
        }, 160);
    }
}
